/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Revenue_reports from "layouts/revenue_reports"
import Generate_Templates from "layouts/generate_templates"
import Car_data_cad_files from "layouts/Car_data_cad_files"
import Manage_templates from "layouts/manage_templates"
import Send_to_machine from "layouts/send_to_machine"
import Client_Management from "layouts/client_management"
import Licensing_Pricing from "layouts/licensing_pricing"
import Payment_Gateway from "layouts/payment_gateway"
import Support_help from "layouts/support_help"
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Generate Templates",
    key: "generate_templates",
    route: "/generate_templates",
    component: <Generate_Templates/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Car Data & CAD Files",
    key: "car_data_&_cad_files",
    route: "/car_data_&_cad_files",
    component: <Car_data_cad_files />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Manage Templates",
    key: "manage_templates",
    route: "/manage_templates",
    component: <Manage_templates />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Send to Machine",
    key: "send_to_machine",
    route: "/send_to_machine",
    component: <Send_to_machine />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Client Management",
    key: "client_management",
    route: "/client_management",
    component: <Client_Management />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Licensing & Pricing",
    key: "licensing_pricing",
    route: "/licensing_pricing",
    component: <Licensing_Pricing />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Payment Gateway",
    key: "payment_gateway",
    route: "/payment_gateway",
    component: <Payment_Gateway />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Revenue Reports",
    key: "revenue_reports",
    route: "/revenue_reports",
    component: <Revenue_reports />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Support & Help",
    key: "support_help",
    route: "/support_help",
    component: <Support_help />,
    noCollapse: true,
  },
  { type: "title", title: "Account Pages", key: "account-pages" },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <SignIn />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    icon: <SpaceShip size="12px" />,
    component: <SignUp />,
    noCollapse: true,
  },
];

export default routes;
